// extracted by mini-css-extract-plugin
export default {"root":"CallButton_root__w53pw","icon":"CallButton_icon__PYRXG"};